import { IApiError } from '@frontend/request';

import {
  IChangePasswordParams,
  IExperienceLoginParams,
  IForgotPasswordLiveParams,
  ILoginMobileParams,
  ILoginResponse,
  ILoginWebParams,
  IRequestCrmOtpParams,
  IRequestCrmOtpResponse,
  ISignUpCrmParams,
  authAPI
} from '@aqx-core/common/api/auth';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';
import { ECommonResponseCode } from '@aqx-core/common/request';

class AuthenticationAPIController {
  // CRM live login
  public loginWebCRM = async (params: ILoginWebParams, callbacks: IAPIControllerCallbacks<ILoginResponse>) => {
    try {
      const { result } = await authAPI.loginWebCRM(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public loginMobileCRM = async (params: ILoginMobileParams, callbacks: IAPIControllerCallbacks<ILoginResponse>) => {
    try {
      const { result } = await authAPI.loginMobileCRM(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    } finally {
      callbacks.onFinally?.();
    }
  };

  public logout = async (callbacks: IAPIControllerCallbacks<never>) => {
    try {
      await authAPI.logout();
      callbacks.onSuccess();
    } catch (error) {
      callbacks.onError(error as IApiError);
    } finally {
      callbacks.onFinally?.();
    }
  };

  public changePassword = async (params: IChangePasswordParams, callbacks: IAPIControllerCallbacks<boolean>) => {
    try {
      const { result } = await authAPI.changePassword(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public extendSession = async (callbacks: IAPIControllerCallbacks<ECommonResponseCode>) => {
    try {
      const { code } = await authAPI.extendSession();
      callbacks.onSuccess(code);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public signUpCrm = async (params: ISignUpCrmParams, callbacks: IAPIControllerCallbacks<string>) => {
    try {
      const { result } = await authAPI.signUpCrm(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public requestCrmOtp = async (
    params: IRequestCrmOtpParams,
    callbacks: IAPIControllerCallbacks<IRequestCrmOtpResponse>
  ) => {
    try {
      const { result } = await authAPI.requestCrmOtp(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  // Forgot password for CRM and Live
  public forgotPasswordLive = async (
    params: IForgotPasswordLiveParams,
    callbacks: IAPIControllerCallbacks<ECommonResponseCode>
  ) => {
    try {
      const { code } = await authAPI.forgotPasswordLive(params);
      callbacks.onSuccess(code);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public loginWithExperienceToken = async (
    params: IExperienceLoginParams,
    callbacks: IAPIControllerCallbacks<ILoginResponse>
  ) => {
    try {
      const { result } = await authAPI.loginWithExperienceToken(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    } finally {
      callbacks.onFinally?.();
    }
  };

  public loginWithExperienceExtendToken = async (
    params: IExperienceLoginParams,
    callbacks: IAPIControllerCallbacks<ILoginResponse>
  ) => {
    try {
      const { result } = await authAPI.extendToken(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    } finally {
      callbacks.onFinally?.();
    }
  };
}

export const authenticationAPIController = new AuthenticationAPIController();
